<template>
  <div class="tak-title">
    <el-checkbox v-if="!edit" v-model="complete" :disabled="!editData.edit_permission || editData.isDisabledProject" @change="change"></el-checkbox>
    <div v-if="!isShowEdit && !edit" class="task-title-wrap ellipsis hover-style" :class="{'hover-style-rest':!editData.edit_permission || editData.isDisabledProject,'complete':complete}" style="flex: 1" @click="editTitle">
      <toolTip class="task-title" style="width:100%;" :title="taskName">
        <span class="tak-title-span">{{taskName}}</span>
      </toolTip>
    </div>
    <el-input v-else class="task-title-input" :readonly="!editData.edit_permission || editData.isDisabledProject" v-model="name" ref="inputs" @blur="dataSend" clearable placeholder="请输入任务标题" size="mini" maxlength="80"></el-input>
  </div>
</template>
<script>

export default {
  props: ['taskStatus', 'taskName', 'editData', 'edit', 'isCompete'],
  data() {
    return {
      isShowEdit: false
    }
  },
  computed: {
    name: {
      get: function () {
        return this.taskName
      },
      set: function (newValue) {
        this.$emit('update:taskName', newValue)
      }
    },
    complete: {
      get: function () {
        return this.taskStatus === '已归档' ? this.isCompete : this.taskStatus === '已完成'
      },
      set: function (val) {
        this.$emit('update:taskStatus', val ? '已完成' : '进行中')
        this.$emit('finishTask', val)
      }
    }
  },
  mounted() {
    if (this.edit) {
      this.$refs['inputs'].focus()
    }
  },
  methods: {
    editTitle() {
      if (!this.editData.edit_permission || this.editData.isDisabledProject) { return }
      this.isShowEdit = !this.isShowEdit
      this.$nextTick(() => {
        this.$refs["inputs"].focus()
      });
    },
    change() {
      this.isShowEdit = false
      this.$emit('change')
    },
    dataSend() {
      if (this.name === '' || this.name === this.editData.task_name) {
        this.name = this.editData.task_name
      } else {
        this.change()
      }
      this.isShowEdit = false
    }
  }
}
</script>
<style lang="scss">
.tak-title {
  font-size: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
  height: 40px;
  .tak-title-span {
    line-height: 40px;
  }
  .el-input {
    height: 100%;
    input::-webkit-input-placeholder {
      font-size: 14px;
      font-weight: normal;
    }
  }
  .el-input__inner {
    height: 100%;
    font-size: 18px !important;
    padding: 0px 8px;
    line-height: 40px;
    font-weight: 500;
    padding-right: 32px;
  }
  .el-checkbox {
    margin-right: 8px;
  }
  .task-title-input {
    .el-input__clear {
      line-height: 40px;
    }
    .el-input__inner {
      font-size: 16px;
    }
  }
  .task-title-wrap {
    height: 100%;
  }
  .complete {
    opacity: 0.4;
  }
}
</style>
